// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ix","image":"iy","contentContainer":"iz","mainText":"iA","subText":"iB","counter":"iC"};